import * as actions from './actions';

const initialize = () => (dispatch) => {
  dispatch(actions.checkEncore());
  dispatch(actions.checkResto());
  dispatch(actions.checkUserService());
};

export { initialize };
